import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=0f972293&scoped=true&"
import script from "./JobDetails.vue?vue&type=script&lang=ts&"
export * from "./JobDetails.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=0f972293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f972293",
  null
  
)

export default component.exports